import {
  CreateLmsCurriculumDto,
  LmsCurriculum,
  UpdateLmsCurriculumDto,
  UserLevel,
} from 'src/graphql/generated/graphql';
import { Form } from './types';
import dayjs from 'dayjs';

export const mapLmsCurriculumToFormData = (entity?: LmsCurriculum): Form => ({
  id: entity?.id,
  name: entity?.name || '',
  description: entity?.description || undefined,
  cost: entity?.cost || '',
  certificateIds: entity?.certificates?.map((certificate) => certificate.id),
  requiredCertificatesConfig: entity?.requiredCertificatesConfig,
  changesLevelTo: entity?.changesLevelTo as UserLevel,
  estimatedTime: entity?.estimatedTime || '',
  externalId: entity?.externalId,
  link: entity?.link,
  mode: entity?.mode,
  startsAt: entity?.startsAt ? dayjs(entity.startsAt) : null,
  finishesAt: entity?.finishesAt ? dayjs(entity.finishesAt) : null,
  adminNotes: entity?.adminNotes || '',
  programId: entity?.program?.id,
});

export const mapFormDataToLmsCurriculumDto = ({
  form,
}: {
  form: Form;
}): CreateLmsCurriculumDto | UpdateLmsCurriculumDto => {
  return {
    name: form.name,
    description: form.description,
    cost: form.cost,
    changesLevelTo: form.changesLevelTo,
    estimatedTime: form.estimatedTime,
    externalId: form.externalId,
    link: form.link,
    mode: form.mode,
    startsAt: form.startsAt,
    finishesAt: form.finishesAt,
    certificateIds: form.certificateIds,
    adminNotes: form.adminNotes,
    requiredCertificatesConfig: form.requiredCertificatesConfig,
    programId: form.programId,
  };
};
